<template>
	<ul
		class="sub-links"
		:data-metrics-section="currentFooterIndex"
		v-metric="{ section: currentFooterIndex, sel: 'li' }"
	>
		<li
			v-for="(subLink, $index) in userSelectedItem.link_items.link_item"
			:key="$index"
		>
			<a
				:href="subLink.link_friendlyUrl"
				v-metric="{ link: $index + 1 }"
				:rel="!subLink.link_friendlyUrl.includes('webmd.com') ? 'nofollow' : null"
			>
				{{ subLink.link_text }}
			</a>
		</li>
		<li v-if="isCcpa && userSelected.toLowerCase() === 'policies'">
			<a
				href="#"
				@click.prevent="showFooterBanner()"
			>
				Cookie Preferences
			</a>
		</li>
	</ul>
</template>
<script>
export default {
	name: 'FooterSubLinks',
	props: {
		metrics: {
			type: Object,
			required: true,
		},
		currentFooterIndex: {
			type: Number,
			required: true,
		},
		userSelectedItem: {
			type: Object,
			required: true,
		},
		userSelected: {
			type: String,
			required: true,
		},
		showFooterBanner: {
			type: Function,
			required: true,
		},
		isCcpa: {
			type: Boolean,
			required: true,
		},
		// eslint-disable-next-line vue/require-default-prop
		data: {
			type: Object,
		},
	},
};
</script>
